import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoGraphicSwiper from 'eco-design/sections/eco-graphic-swiper';
import { EcoGraphicSwiperItemProps } from 'eco-design/sections/eco-graphic-swiper/props';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.ListA3');
    const itemsA: EcoGraphicSwiperItemProps[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745046765186/list_a3_1.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
            lChildren: t('item1_btn'),
            lHref: 'https://www.ecoflow.com/jp/wave-3-and-glacier-classic',

            lType: 'outlined',
            lTheme: 'blue',
            lRadius: 'ellipse',
            lIsWithRightArrow: true,
            lDataLayer: {
                event: 'uaEvent',
                event_name: 'select_product',
                list_name: 'Product Preview',
                product_name: 'wave-3-and-glacier-classic',
                button_name: t('item1_btn'),
            },
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745046765522/list_a3_2.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
            lChildren: t('item2_btn'),

            lHref: 'https://jp.ecoflow.com/pages/camp-portable-power-station',

            lType: 'outlined',
            lTheme: 'blue',
            lRadius: 'ellipse',
            lIsWithRightArrow: true,
            lDataLayer: {
                event: 'uaEvent',
                event_name: 'buy',
                product_name: 'camp-portable-power-station',
                position: 'Product Detail',
            },
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745046765361/list_a3_3.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
            lChildren: t('item3_btn'),

            lHref: 'https://jp.ecoflow.com/products/ecoflow-220w-solarpanel-new',

            lType: 'outlined',
            lTheme: 'blue',
            lRadius: 'ellipse',
            lIsWithRightArrow: true,
            lDataLayer: {
                event: 'uaEvent',
                event_name: 'buy',
                product_name: 'ecoflow-220w-solarpanel-new',
                position: 'Product Detail',
            },
        },
    ];
    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoGraphicSwiper imgHeight="5-3" items={itemsA} layout="swiper" />
        </div>
    );
}
